<template>
  <div>
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <v-sheet>
      <v-row>
        <v-col cols="12">
          <div>
            <v-btn
              small
              class="text-capitalize float-right ma-2"
              color="primary"
              dark
              width="100"
              :loading="editing"
              @click="editModel()"
              >{{ $t("Edit") }}</v-btn
            >
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-form class="main-form pa-3" ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('Name')"
                    v-model="model.name"
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>
<script>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { AdminRoles } from "@/models/AdminRolesEnum";
import RestResourceModel from "../../api/apiModelService";
export default {
  name: "EditModel",
  props: {
    modelProp: Object
  },
  components: {},
  data() {
    return {
      roles: AdminRoles,
      editing: false,
      errorAlert: false,
      errorMsg: "",
      model: {
        _id: "",
        name: ""
      },
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        }
      }
    };
  },
  watch: {
    modelProp: {
      handler() {
        this.model = Object.assign({}, this.modelProp);
      },
      deep: true
    }
  },
  methods: {
    editModel() {
      if (this.$refs.form.validate()) {
        this.editing = true;
        RestResourceModel.prototype
          .putModel(this.model._id, {
            name: this.model.name
          })
          .then(response => {
            if (response && response.status == ResponseStatus.OK) {
              this.$router.push({ name: "brands_list" });
            }
            this.editing = false;
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.editing = false;
          });
      }
    }
  }
};
</script>
<style></style>
